export default __webpack_public_path__ + "static/trustbadge-21b248106b3bb833d2590c851dcc5611.webp";